import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { PAGE_HEADER_TABS_LABEL } from "../../messages";
import { usePageHeaderTabs } from "../../use-page-header-tabs";
import type { PageHeaderTabsProps, PageHeaderTabsViewModel } from "./types-tabs";

/**
 * ViewModel das abas por rota (`TabMenu`): a aba da rota atual como `activeIndex` e a navegação por teclado (Enter/Espaço, que o
 * Prime trata e cancela; o clique é do `Link`); sem JSX.
 */
export function useTabs({
  items,
  "aria-label": ariaLabel = PAGE_HEADER_TABS_LABEL,
  mobileQuery,
  className,
  ...rest
}: PageHeaderTabsProps): PageHeaderTabsViewModel {
  const navigate = useNavigate();
  const { isMobile, activeItem } = usePageHeaderTabs(items, { mobileQuery });

  const onTabChange = useCallback(
    ({ index }: { index: number }) => {
      const item = items[index];
      if (item && !item.disabled) navigate(item.to);
    },
    [items, navigate],
  );

  return {
    isMobile,
    items,
    activeIndex: activeItem ? items.indexOf(activeItem) : -1,
    onTabChange,
    ariaLabel,
    mobileQuery,
    className,
    rest,
  };
}
